import Vue from 'vue'
import App from './App.vue'
//import wrap from '@vue/web-component-wrapper';
import { Store } from './store/index.js'

Vue.config.productionTip = false

new Vue({
  store: Store,
  render: h => h(App)
}).$mount("#app");

/*
const CustomElement = wrap(Vue, App);
window.customElements.define('trioteca-widget', CustomElement);
*/